/* eslint-disable no-unused-vars, camelcase */
import type { MediaPrivacy } from './../../wix-ricos-common';
import { MEDIA_SERVICES_URL } from './../../wix-ricos-common';
import type { GetWixClientPromise } from './../../_shared/request-service-provider/use-get-wix-client-promise';

import type {
  MediaManagerSDKError,
  RawAudioData,
  RawFileData,
  RawImageData,
  RawVideoData,
} from './uploadTypes';

export class MediaManagerUploader {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly getWixClientPromise: GetWixClientPromise,
    private readonly consumer?: string,
    private readonly folderId?: string | null
  ) {}

  // @todo: next-major - add generics, so the return value isnt a union type
  async upload(
    file: File,
    type: string,
    options?: {
      privacy?: MediaPrivacy;
      onUploadProgress?: (progressEvent: any) => void;
    }
  ): Promise<RawImageData & RawVideoData & RawAudioData & RawFileData> {
    const { privacy = 'public', onUploadProgress } = options || {};

    const params = new URLSearchParams({ mediaType: type, privacy });
    const wixClient = await this.getWixClientPromise();
    const response = await wixClient.fetchWithAuth(
      `${MEDIA_SERVICES_URL}/upload-url?${params.toString()}`,
      { method: 'POST', body: JSON.stringify({}) }
    );

    const responseData: { uploadUrl: string } = await response.json();

    const uploadUrl: string = responseData.uploadUrl;
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('media_type', type);
    formData.append('acl', privacy);
    if (this.consumer) {
      formData.append('tags', `rich_content_${this.consumer}`);
    }
    if (this.folderId) {
      formData.append('parent_folder_id', this.folderId);
    }

    const requestConfig = {
      onUploadProgress: (progressEvent: $TSFixMe) => {
        onUploadProgress?.(progressEvent);
      },
    };

    const uploadResponse = await wixClient.fetchWithAuth(uploadUrl, {
      method: 'POST',
      body: formData,
      ...requestConfig,
    });

    const uploadRepsonseJson: [RawImageData & RawVideoData & RawAudioData & RawFileData] &
      MediaManagerSDKError = await uploadResponse.json();
    const { error_description } = uploadRepsonseJson;
    return new Promise((resolve, reject) =>
      error_description ? reject(uploadRepsonseJson) : resolve(uploadRepsonseJson[0])
    );
  }
}
